import React from "react";

import InfoDateContainer from "./InfoDateContainer";
import InfoEmpty from "./InfoEmpty";
import InfoPanel from "./InfoPanel";

const OnlyTimeInfoPanel = () => (
	<InfoPanel>
		<InfoEmpty height="450px" />
		<InfoDateContainer />
	</InfoPanel>
);

export default OnlyTimeInfoPanel;
